var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-checkbox', {
    attrs: {
      "input-value": _vm.enabled,
      "ripple": false
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('update:enabled', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t("components.partner.TicketCreateCheckbox.prefix")) + " "), _c('span', {
          staticClass: "inline-field",
          on: {
            "click": function click($event) {
              $event.stopPropagation();
            },
            "mousedown": function mousedown($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('v-text-field', {
          staticClass: "date-input",
          attrs: {
            "type": "date",
            "min": _vm.todayISO,
            "readonly": _vm.disabled,
            "dense": "",
            "hide-details": ""
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
            },
            "keydown": function keydown($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: _vm.dateModel,
            callback: function callback($$v) {
              _vm.dateModel = $$v;
            },
            expression: "dateModel"
          }
        })], 1), _vm._v(" " + _vm._s(_vm.$t("components.partner.TicketCreateCheckbox.suffix")) + " ")];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }